import styled from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Image } from '../image/image.component';

import { ChildrenContainerProps, ChooseBoxContainerProps } from './chooseBox.types';

export const Container: StyledComponent<'div'> = styled.div`
  min-height: 76px;
`;

export const ChooseBoxContainer: StyledComponent<'div', ChooseBoxContainerProps> = styled.div<ChooseBoxContainerProps>`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between; 
  border: 1px solid ${({ $isActive }: ChooseBoxContainerProps): string => $isActive ? Color.Error500 : Color.Gray300};
  cursor: pointer;
  transition: 0.3s;
  padding-right: 24px;
`;

export const Title: StyledComponent<'div'> = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: ${Color.Black};
`;

export const SubTitle: StyledComponent<'div'> = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: ${Color.Gray500};
`;

export const DetailsContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
`;

export const RadioContainer: StyledComponent<'div'> = styled.div`
  height: 76px;
  display: flex;
  align-items: center;
  padding: 0 24px;
`;

export const TitlesContainer: StyledComponent<'div'> = styled.div``;

export const ImageContainer: StyledComponent<'div'> = styled.div`
  width: 76px;
  height: 76px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;

export const Logo: StyledComponent<typeof Image> = styled(Image)`
  width: 42px;
  height: auto;
`;

export const CollapsedChildrenWrapper: StyledComponent<'div'> = styled.div``;

export const ChildrenContainer: StyledComponent<'div', ChildrenContainerProps> = styled.div<ChildrenContainerProps>`
  padding: 24px;
  margin: 0;
  border: 1px solid ${({ $isActive }: ChildrenContainerProps): Color => $isActive ? Color.Error500 : Color.Gray300};
  border-top: none;
`;

export const UnderlineButton: StyledComponent<'button'> = styled.button`
  font-size: 14px;
  font-weight: ${FontWeight.Medium};
  line-height: 18px;
  color: ${Color.Gray500};
  text-decoration-line: underline;
`;

export const IconButton: StyledComponent<'button'> = styled.button``;
